import styled from 'styled-components';

export const Content = styled.main`
  background: #FFF;
  border-radius: 8px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05), 0px 6px 12px rgba(61, 69, 67, 0.05);

  width: 100%;
  padding: 30px 25px;
  margin: 0 5px;

  display:flex;
  flex-direction: column;
  align-items: center;

  strong {
    font-size: 16px;
    text-align: center;
    margin-bottom: 12px;
    color: #0071BA;
  }

  img {
    height:185px;
    width: auto;
    margin: 30px 0px;
  }

  p {
    width: 80%;
    font-size: 14px;
    text-align: center;
    line-height:18px;
    padding-bottom: 20px;
  }

  > div {
    display: flex;
    flex-direction: column;
    align-items: center;

    a {
      color: #333333;
      text-decoration: none;
      display: flex;
      align-items: center;
      position: relative;

      &:focus, &:hover{
        text-decoration: underline;
      }
    }
 }
`

export const HandleNew = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  margin: 15px 0;
  width: 100%;

  h4 {
    font-size: 14px;
    color: #0071BA;
  }

  > div {
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    a {
      text-align: center;
      margin: 0 auto;
      font-weight: bold;
    }

    p {
      margin: 0;
      padding: 5px 0;
    }
  }
`
